@if (!contentLoaded) {
  <app-content-loader></app-content-loader>
}

@if (contentLoaded) {
  <div class="step-container columns is-desktop tax-documents-page">
    <app-aside-bar
      [showEvenWithoutStatement]="false"
      [statement]="statement"
      [workFlowController]="workFlowController"
    ></app-aside-bar>

    <div class="tax-documents">
      <div class="tax-documents__header">
        <h1 class="title_42">{{ "TAX_DOCUMENTS.TITLE" | translate }}</h1>
        <p class="subdesc">{{ "TAX_DOCUMENTS.SUBTITLE" | translate }}</p>
      </div>

      @if (errorMessage) {
        <div class="tax-documents__error">
          {{ errorMessage }}
        </div>
      }

      @if (documentRequest) {
        <div class="tax-documents__content">
          @for (item of documentRequest.items; track item.id) {
            <section class="tax-documents__item">
              <h2>{{ item.name }}</h2>

              @if (item.files?.length) {
                <ul class="tax-documents__file-list">
                  @for (file of item.files; track file.id) {
                    <li>
                      <span>{{ file.original_filename }}</span>
                      @if (!isReadOnly) {
                        <button
                          type="button"
                          class="tax-documents__remove"
                          (click)="removeFile(file.id)"
                          [disabled]="isFileDeleting(file.id) || isSubmitting"
                        >
                          <img src="assets/svg/del_icon.svg" [attr.alt]="'TAX_DOCUMENTS.REMOVE_FILE_ALT' | translate" />
                        </button>
                      }
                    </li>
                  }
                </ul>
              }

              @if (!isReadOnly) {
                <div class="tax-documents__upload">
                  <label [attr.for]="'tax-documents-files-' + item.id">
                    {{ "SEND_MESSAGE_DIALOG.ATTACHMENT.ADD_FILE_BUTTON" | translate }}
                  </label>
                  <input
                    [id]="'tax-documents-files-' + item.id"
                    type="file"
                    multiple
                    accept=".pdf,application/pdf"
                    (change)="onFilesSelected(item.id, $event)"
                    [disabled]="isItemUploading(item.id) || isSubmitting"
                  />
                </div>
              }

              <div class="tax-documents__limits">
                <span>{{ "ADD_ATTACHMENT.ONLY_PDF" | translate }}</span>
                <span>{{ "ADD_ATTACHMENT.MAX_FILE_SIZE_10_MB" | translate }}</span>
                <span>{{ "ADD_ATTACHMENT.MAX_FILE_NUMBER" | translate }} 10</span>
                <span>{{ "ADD_ATTACHMENT.MAX_PAGE_NUMBER" | translate }}</span>
              </div>
            </section>
          }

          <div class="tax-documents__note">
            <label for="tax-documents-note">{{ "TAX_DOCUMENTS.ADDITIONAL_INFO_LABEL" | translate }}</label>
            <textarea
              id="tax-documents-note"
              [ngModel]="clientNote"
              (ngModelChange)="onClientNoteChange($event)"
              [placeholder]="'TAX_DOCUMENTS.NOTE_PLACEHOLDER' | translate"
              [disabled]="isReadOnly || isSubmitting"
              rows="6"
            ></textarea>
          </div>
        </div>
      }
    </div>

    <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
  </div>
}
